import '@hotwired/turbo-rails'
import '../controllers'
import $ from 'jquery';
import 'jquery-ui/dist/jquery-ui'
import 'jquery-ui/ui/effects/effect-slide'
import 'jquery-ui/ui/widgets/slider'
import '@popperjs/core'
// import 'bootstrap'
import * as bootstrap from "bootstrap";

window.$ = $;
Turbo.session.drive = false

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

console.log('Vite ⚡️ Rails')
console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')
